import apiClient from "./apiClient";

const BASE = "/api/Shade";

// API returns shadeID (no `id`) — alias it so list/edit code using `.id` works.
const withId = (s) => ({ ...s, id: s.shadeID });

export const getShades = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const createShade = (data) => apiClient.post(`${BASE}/save`, data);
export const updateShade = (id, data) => apiClient.post(`${BASE}/save`, { ...data, shadeID: id });
export const deleteShade = (id) => apiClient.delete(`${BASE}/${id}`);
